var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"mb-3",attrs:{"header-tag":"header"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n            Audit Trail\n        ")]),_vm._v(" "),_c('b-table',{attrs:{"bordered":"","striped":"","hover":"","show-empty":"","items":_vm.audit_trail,"fields":_vm.fields}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }